import React, { useState, useRef, useEffect, memo, useContext } from "react";
import pdf_icon from "../../assets/img/pdf-icon.png";
import word_icon from "../../assets/img/word-icon.png";
import excl_icon from "../../assets/img/excl-icon.png";
import csv_icon from "../../assets/img/csv-icon.png";
import other_file_icon from "../../assets/img/other-file-icon.png";
import audio_file_icon from "../../assets/img/audioF.png"
import ppt_icon from "../../assets/img/ppt-icon.png"
import download_icon from "../../assets/img/download-icon.png";
import single_tick_icon from "../../assets/img/single-tick.png";
import double_tick_icon from "../../assets/img/double-tick.png";
import double_tick_read_icon from "../../assets/img/double-tick-read.png";
import { formatTime, getDisplayFileName, getExtensionType, audioformatTime } from "../../utils";
import ContextMenu from "../../utils/ContextMenu";
import { toast } from "react-toastify";
import { IMAGE_URL } from "../../configs/api";
import useDownloader from "react-use-downloader";

const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg", "tiff", "ico", "avif", "heic"];
const documentExtensions = ["pdf", "doc", "docx", "txt", "ppt", "pptx", "csv", "xls", "xlsx"];
const extensionIcons = { pdf: pdf_icon, doc: word_icon, docx: word_icon, txt: word_icon, ppt: ppt_icon, pptx: ppt_icon, csv: csv_icon, xls: excl_icon, xlsx: excl_icon };
const audioExtensions = [
  "3gp", "aa", "aac", "aax", "ac3", "aiff", "alac", "amr", "ape", "au",
  "dts", "flac", "gsm", "m4a", "m4b", "m4p", "mka", "mlp", "mod", "mp3",
  "mpa", "mpc", "msv", "oga", "ogg", "opus", "ra", "ram", "raw", "snd",
  "spx", "tta", "voc", "vqf", "wav", "wma", "wv"
];
const Message = ({
  msg,
  currGroup,
  senderName,
  messagesEndRef,
  deleteChatFlag,
  setDeleteChatFlag,
  isDelMsgSelected,
  handleCheckDelMsgChange,
  isFwdMsgSelected,
  handleCheckForwardNessage,
  forwardChatFlag,
  setForwardChatFlag,
  setReplyChatFlag,
  setReplyMsg,
  openPreview,
  currentlyPlayingAudio,
  setCurrentlyPlayingId,
  isPlaying,
  onAudioPlay,
}) => {
  const loginData = JSON.parse(localStorage.getItem("loginData"));

  const { download } = useDownloader();
  const audioRef = useRef(null);

  const currentUserId = loginData?.id?.toString();
  const [isExpanded, setIsExpanded] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [contextMenu, setContextMenu] = useState({
    show: false,
    position: { x: 0, y: 0 }
  });

    useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;
    
    const updateTime = () => setCurrentTime(audio.currentTime);
    audio.addEventListener("timeupdate", updateTime);
    
    return () => {
      audio.removeEventListener("timeupdate", updateTime);
    };
  }, [setCurrentTime]);
  
  useEffect(() => {
    if (audioRef.current && msg?.mediaUrl) {
      audioRef.current.load();
    }
  }, [msg?.mediaUrl]);

  const tickIcons={
    0:single_tick_icon,
    1:double_tick_icon,
    2:double_tick_read_icon
  } 

  /*---context mexu operation---*/
  const handleContextMenu = (e) => {
    e.preventDefault();
    setContextMenu({
      show: true,
      position: { x: e.clientX, y: e.clientY }
    });
  };

  const handleMenuClose = () => {
    setContextMenu({ ...contextMenu, show: false });
  };

  const handleMenuSelect = (action, msg) => {
    switch (action) {
      case 'reply':
        setReplyChatFlag(true);
        setReplyMsg(msg);
        break;
      case 'copy':
        handleCopyMessage(msg?.message);
        break;
      case 'download':
        handleDownload(msg?.mediaUrl,getDisplayFileName(msg?.mediaUrl));
        break;
      case 'forward':
        setForwardChatFlag(true);
        handleCheckForwardNessage(msg);
        break;
      case 'delete':
        setDeleteChatFlag(true);
        // setSelectedMessages([msg.id]);
        handleCheckDelMsgChange(msg?.id)
        break;
      default:
        break;
    }
    handleMenuClose();
  };

  /*---copy message to clipboard---*/
  const handleCopyMessage = (text) => {
    navigator?.clipboard?.writeText(text)
      .then(() => {
        toast.success("Copied to clipboard");
      })
      .catch((err) => {
        console.error('Failed to copy: ', err);
      });
  };

  /*---download file---*/
  const handleDownload = (fileUrl, fileName) => {
    download(fileUrl, fileName);
  };

  const scrollToParent = (parentId) => {
    const parentElement = document.getElementById(`message-${parentId}`);
    if (parentElement) {
      parentElement.scrollIntoView({ behavior: "smooth" });

      // Optional highlight effect
      parentElement.classList.add("highlight-parent");
      setTimeout(() => {
        parentElement.classList.remove("highlight-parent");
      }, 1000);
    }
  };
  
  /*---ext file---*/
  let ext = getExtensionType(msg?.mediaUrl);
  
  return (
    <div
      className={`row message-body ${ msg.userid.toString() === currentUserId ? "message-main-sender" : "message-main-receiver"}`}
      key={`${msg.userid}_${msg.id}`}
    >
      {contextMenu.show && (
        <ContextMenu
          position={contextMenu.position}
          onClose={handleMenuClose}
          onSelect={(action) => handleMenuSelect(action, msg)}
          isSender={msg.userid.toString() === currentUserId}
          isMedia={msg?.mediaUrl}
        />
      )}
      <div className={`col-sm-12 ${ msg.userid.toString() === currentUserId ? "chatdeletebox" : forwardChatFlag ? "msgdeleteflex" : "" }`}>
        <div className="delw60">
          {forwardChatFlag && (
            <input
              type="checkbox"
              checked={isFwdMsgSelected}
              onChange={() => handleCheckForwardNessage(msg)}
            />
          )}
        </div>
        <div
         id={`message-${msg.id}`}
          className={
            `${msg.userid.toString() === currentUserId ? 'sender' : 'receiver'}${msg.mediaUrl && msg.message ? ' image-with-text' : ''}`
          }
        >
          <div className={`message-options-container`}>
            {currGroup?.id && <div className="username">{senderName}</div>}
            <i
              className="fa fa-chevron-down pull-right"
              aria-hidden="true"
              onClick={handleContextMenu}
            ></i>
          </div>

            {/* MEDIA HANDLING */}
          <>
            {audioExtensions?.includes(ext) ? (
              <div className="audio-player-container">
                <div className="audio-control-button" onClick={() => {
                  if (audioRef.current) {
                    onAudioPlay(audioRef.current);
                  }
                }}>
                  <div className="circle">
                    <i className={`fa ${isPlaying && !audioRef.current?.paused
                        ? "fa-pause"
                        : "fa-play"
                      }`} />
                  </div>
                </div>
                <div style={{ display: "ruby" }}>
                  <input
                    type="range"
                    value={currentTime}
                    max={audioRef.current?.duration || 0}
                    onChange={(e) => {
                      if (audioRef.current) {
                        audioRef.current.currentTime = e.target.value;
                        setCurrentTime(e.target.value);
                      }
                    }}
                    className="audio-seek-bar"
                  />
                  <audio
                    ref={audioRef}
                    src={msg?.mediaUrl}
                    onEnded={() => {
                      if (currentlyPlayingAudio === audioRef.current) {
                        setCurrentlyPlayingId(null);
                      }
                    }}
                  />
                </div>
              </div>
            ) : imageExtensions.includes(ext) &&
              msg?.mediaUrl?.includes(IMAGE_URL) ? (
              <>
                <img
                  src={msg?.mediaUrl}
                  alt="image"
                  loading="lazy"
                  style={{ cursor: "pointer", maxWidth: "250px", borderRadius: "6px" }}
                  onClick={() => openPreview(msg)}


                />
                <div className="text-message">{msg?.message}</div>
              </>
            ) : (documentExtensions.includes(ext)) || msg?.mediaUrl?.includes(IMAGE_URL) ? (
              <>
                <div className="allfilebox">
                  <div className="filenameextention">
                    <img
                      className="br5"
                      src={
                        extensionIcons[ext]
                          ? extensionIcons[ext]
                          : other_file_icon
                      }
                      alt={ext}
                    />
                  </div>
                  <div className="filemainname">
                    <div>{getDisplayFileName(msg?.mediaUrl)}</div>
                    {/* <div className="filenamesmall">{ext} .2MB</div> */}
                  </div>
                  <div className="filenamedownload">
                    <a
                      onClick={() => handleDownload(msg?.mediaUrl, getDisplayFileName(msg?.mediaUrl))}
                      download
                    >
                      <img src={download_icon} alt="Download" />
                    </a>
                  </div>
                </div>
                <div className="text-message">{msg?.message}</div>
              </>
            ) : (
              <>
                {msg?.parentMessageId && <div className="reply-section" onClick={() => scrollToParent(msg.parentMessageId)}>
                  <div className={msg.userid.toString() === currentUserId ? `reply-bar-sender` : `reply-bar-receiver`}></div>
                  <div className="reply-text">
                    <div className="reply-username">{msg?.parentUserName === loginData?.userName ? "You" : msg?.parentUserName}</div>
                    <div> {msg?.parentMessage?.length > 20
                      ? msg.parentMessage.slice(0, 20) + "..."
                      : msg?.parentMessage}
                    </div>
                  </div>
                  {msg?.parentMediaUrl && <div className="reply-image"><img src={imageExtensions.includes(msg?.parentMediaUrl.split(".").pop().toLowerCase()) ? msg?.parentMediaUrl
                    : extensionIcons[msg?.parentMediaUrl.split(".").pop().toLowerCase()] ? extensionIcons[msg?.parentMediaUrl.split(".").pop().toLowerCase()] : audioExtensions.includes(msg?.parentMediaUrl.split(".").pop().toLowerCase()) ? audio_file_icon : other_file_icon
                  } /></div>}
                </div>}
                <div className={`text-message ${isExpanded ? 'expanded' : ''}`}>{msg?.message}</div>
                {msg?.message.length > 800 && (
                  <span
                    className="read-more"
                    onClick={() => setIsExpanded(!isExpanded)}
                  >
                    {isExpanded ? 'Read less' : 'Read more'}
                  </span>
                )}
              </>
            )
            }
          </>
          <span className="message-time pull-right tick15 tickbox">
            {audioExtensions.includes((msg.mediaUrl || "").split(".").pop().toLowerCase()) && <span className="audio-time">{audioformatTime(Math.floor(currentTime))}</span>}
           <span>{formatTime(msg?.date)}</span>
           {msg.userid.toString() === currentUserId && !currGroup?.id && <img className="" src={tickIcons[msg.readstatus]}/> }
          </span>
          <div ref={messagesEndRef} />
        </div>
          {msg.userid.toString() === currentUserId && deleteChatFlag && (
            <div className="sender-check-box">
              <input
                type="checkbox"
                checked={isDelMsgSelected}
                onChange={() => handleCheckDelMsgChange(msg.id)}
              />
            </div>
          )}
      </div>
    </div>
  );
};

export default memo(Message);